export default __webpack_public_path__ + "media/images/vcf_icon-a82752da49c899cdd1c91cd32a3874d9.png";